import Table, { ColumnsType } from "antd/lib/table";
import { formatDateString } from "../../Helpers/DateHelpers";
import { TextService } from "../../Services/TextService";
import { DeleteOutlined } from "@ant-design/icons";
import { Col, Input, Popconfirm, Row, Select, Space } from "antd";
import { useState } from "react";
import { InviteService } from "../../Services/InviteService";

const ALL = "all";
const REPLIED = "replied";
const NOT_REPLIED = "notReplied";

export const InviteList = (props: any) => {
    const [inviteToDelete, setInviteToDelete] = useState(0 as number);
    const [searchText, setSearchText] = useState("");
    const [repliedFilter, setRepliedFilter] = useState(ALL as string);

    const GetText = TextService.GetText;
    interface DataType {
        key: string;
        customerName: string;
        customerEmail: string;
        id: number;
        times: any[];
        tags: string[];
    }

    const onDeleteClick = (memberId: number) => {
        setInviteToDelete(memberId);
    };

    const handleOk = async () => {
        await InviteService.DeleteInvite(inviteToDelete.toString());
        setInviteToDelete(0);
        props.loadEvent(props.event.eventUniqueId);
    };


    const inviteColumns: ColumnsType<DataType> = [
        {
            title: GetText("InviteList_EmailColumn"),
            dataIndex: 'email',
            key: 'email',
            sorter: (a: any, b: any) => (a.email ?? "").localeCompare(b.email ?? "", "sv"),
            render: (_, invite: any) => (
                <span>{invite.email}<br />
                </span>
            ),
        },
        {
            title: GetText("InviteList_SentColumn"),
            dataIndex: 'sent',
            key: 'sent',
            sorter: (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
            render: (_, invite: any) => (
                <span>{formatDateString(invite.createdAt)}<br />
                </span>
            ),
        },
        {
            title: GetText("InviteList_RepliedColumn"),
            dataIndex: 'Answer',
            key: 'Answer',
            sorter: (a: any, b: any) => (a.replyId === 0 ? 0 : 1) - (b.replyId === 0 ? 0 : 1),
            render: (_, invite: any) => (
                <span>{invite.replyId === 0 ? GetText("Common_No") : GetText("Common_Yes")}<br />
                </span>
            ),
        },
        {
            title: GetText("InviteList_LinkColumn"),
            dataIndex: 'Invite',
            key: 'Invite',
            render: (_, invite: any) => (
                <Space size="middle">
                    <span><a target="_blank" href={process.env.REACT_APP_WEB_URL + "/Event/" + props.event.eventUniqueId + "/invite/" + invite.uniqueId}>{GetText("InviteList_InviteLinkText")}</a>
                    </span>
                    <DeleteOutlined style={{ color: "red", fontSize: "20px" }} onClick={() => onDeleteClick(invite?.id!)}></DeleteOutlined>

                    <Popconfirm
                        title={GetText("InviteList_DeleteInviteConfirmMessage")}
                        key={invite.id}
                        open={invite.id === inviteToDelete}
                        placement="topRight"
                        onConfirm={handleOk}
                        onCancel={() => setInviteToDelete(0)}
                    >
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    if (props.invites.length === 0) {
        return <span><i>{GetText("InviteList_NoInvitesYet")}</i></span>;
    }

    const search = searchText.trim().toLowerCase();
    const filteredInvites = props.invites.filter((invite: any) =>
        (invite.email ?? "").toLowerCase().includes(search)
        && (repliedFilter === ALL || (repliedFilter === REPLIED) === (invite.replyId !== 0)));
    const isFiltered = filteredInvites.length !== props.invites.length;

    return <>
        <Row gutter={[8, 8]} style={{ marginBottom: "10px" }}>
            <Col flex="auto">
                <Input.Search allowClear placeholder={GetText("InviteList_SearchPlaceholder")} value={searchText} onChange={(e) => setSearchText(e.target.value)} />
            </Col>
            <Col flex="none">
                <Select style={{ minWidth: 160 }} value={repliedFilter} onChange={setRepliedFilter} options={[
                    { value: ALL, label: GetText("InviteList_FilterAll") },
                    { value: REPLIED, label: GetText("InviteList_FilterReplied") },
                    { value: NOT_REPLIED, label: GetText("InviteList_FilterNotReplied") }
                ]} />
            </Col>
        </Row>
        <Table columns={inviteColumns} rowKey="id" dataSource={filteredInvites} scroll={{ x: 'max-content' }}
            locale={{ emptyText: GetText("ReplyTable_NoMatches") }}
            pagination={{
                defaultPageSize: 20,
                showSizeChanger: true,
                locale: { items_per_page: "/ " + GetText("Common_Page") },
                hideOnSinglePage: props.invites.length <= 20,
                showTotal: (total) => isFiltered ? `${total} ${GetText("Common_Of")} ${props.invites.length} ${GetText("InviteList_Invites")}` : `${total} ${GetText("InviteList_Invites")}`
            }} />
    </>;
};